var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-main-wrapper o-layout"},[_c('event-menu',{staticClass:"o-layout__item u-2-of-7-at-medium u-2-of-8-at-large",attrs:{"sessionId":_vm.$route.params.sessionId}}),_c('div',{staticClass:"c-main c-main--after-sidebar o-layout__item u-5-of-7-at-medium u-6-of-8-at-large"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }